'use client';

import { useState } from 'react';
import { SectionWrapper } from '../shared';
import { BillingCycle, PricingCarousel, PricingPlan } from '@/components/pricing/PricingCarousel';
import { formatRupiahInput } from '@/lib/kurator/format-rupiah';
import { useAnalytics } from '@/services/frontendAnalyticsService';

const BASIC_PLAN: PricingPlan = {
  title: 'Basic',
  price: 'Gratis',
  period: '',
  description:
    'Mulai eksplorasi database peraturan tanpa biaya. Sempurna untuk kebutuhan pencarian dasar.',
  features: [
    'Akses Penuh Database Peraturan',
    'Pencarian Konteks Tingkat Peraturan',
    'Pemetaan Relasi Peraturan Dasar',
  ],
  bgClass: 'bg-white',
  ctaText: 'Mulai Gratis',
  href: '/id/home',
};

export function LandingPricing() {
  const [billingCycle, setBillingCycle] = useState<BillingCycle>('monthly');
  const analytics = useAnalytics();

  const proMonthlyPrice = '400.000';
  const proAnnualPrice = '320.000';
  const proPrice = billingCycle === 'monthly' ? proMonthlyPrice : proAnnualPrice;
  const proOriginalPrice = billingCycle === 'annual' ? proMonthlyPrice : undefined;
  const proPeriod = billingCycle === 'monthly' ? '/ bulan' : '/ bulan, dibayar tahunan';

  const proAnnualTotalText =
    billingCycle === 'annual' ? `Total Rp ${formatRupiahInput(320_000 * 12)}/tahun` : undefined;

  const proAnnualSavingsText =
    billingCycle === 'annual'
      ? `Hemat Rp ${formatRupiahInput((400_000 - 320_000) * 12)} dibanding bulanan`
      : undefined;

  const proPlan: PricingPlan = {
    title: 'Professional',
    price: proPrice,
    originalPrice: proOriginalPrice,
    period: proPeriod,
    annualTotalText: proAnnualTotalText,
    annualSavingsText: proAnnualSavingsText,
    description:
      'Kekuatan penuh analitik hukum, kecerdasan buatan, dan database tak terbatas untuk produktivitas maksimal.',
    features: [
      'Semua fitur di paket Basic',
      'Dashboard Personal & Manajemen Bookmark Peraturan/Pasal',
      'Pemetaan Relasi antar Aturan dan Pasal',
      'Rangkuman Peraturan',
      'Drafting Dokumen Hukum dengan AI',
    ],
    highlightedFeatures: [
      'Akses Penuh 4500+ Peraturan Konsolidasi',
      'Agen Riset AI dengan Visualisasi Flowchart Otomatis',
      'Pencarian Pasal dan Aturan Menggunakan Konteks',
    ],
    bgClass: 'bg-neutral-50',
    isPopular: true,
    ctaText: 'Mulai Paket Professional',
    href: '/payment?plan=professional',
  };

  const plans = [BASIC_PLAN, proPlan];

  return (
    <SectionWrapper background="white" padding="md" containerSize="xl">
      <PricingCarousel
        plans={plans}
        billingCycle={billingCycle}
        onBillingCycleChange={setBillingCycle}
        onCTAClick={(plan) => {
          analytics.landingPage.planSelected({
            planName: plan.title,
            billingCycle,
          });
        }}
        title="Investasi yang memberikan keuntungan berkali lipat"
        description="Pilih paket yang sesuai dengan kebutuhan Anda. Mulai eksplorasi tanpa biaya, atau buka semua kekuatan AI untuk produktivitas maksimal."
      />
    </SectionWrapper>
  );
}
